import { dispatch } from 'store'
import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import AiImageGenerationTabTitle from '../../../components/Title'
import ModelDropdown from 'containers/SubSidebar/AiImageContent/components/ModelDropdown'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiImageSelectors } from 'store/features/aiImage/selectors'
import { AiImageGenerateOption } from '../styled'

const AiImageGenerationModel: React.FC = () => {
  const modelsData = useSelector(aiImageSelectors.modelsData)
  const modelCode = useSelector(aiImageSelectors.modelCode)

  const handleModelSelect = useCallback(
    (selectedModelCode: string) => {
      if (modelCode !== selectedModelCode) {
        dispatch(aiImageThunks.setModelCode(selectedModelCode))
      }
    },
    [modelCode]
  )

  return (
    <AiImageGenerateOption>
      <AiImageGenerationTabTitle>
        {translate(T.MODEL_LABEL)}
      </AiImageGenerationTabTitle>
      <ModelDropdown
        models={modelsData}
        selectedModelCode={modelCode}
        onModelSelect={handleModelSelect}
      />
    </AiImageGenerateOption>
  )
}

export default AiImageGenerationModel
